import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import {config, izBlank, LOG_OUT} from '../../constants';
import AuthService from '../../services/auth.service';
import i18n from 'i18next';
import { Button, DatePicker, Input, message, Select, Switch} from 'antd';
import { EditOutlined, ReadOutlined } from '@ant-design/icons';
import moment from 'moment';


export default class AddOrUpdateCompanyComponent extends React.Component{

    constructor(props){
        super(props);

        const companyID = this.props.match.params.companyID
        const pageMode = companyID ? "update" : "add";

        this.state = {
            pageMode: pageMode,
            companyID: companyID,
            licenseTypes: [],
            licenseUsageTypes: [],
            company: {
                licenseType:"COMPANY",
                licenseUsageType:"MONTHLY",
                uniqueCode: "",
                enabled: true,
                startDate: moment(),
                endDate: moment(),
                }
        }

        if(this.state.pageMode == "update"){axios.get(config.API_URL + "company/" + companyID, {headers: authHeader()}).then(response => {

            var companyData = response.data

            this.setState({company:companyData})

        })}
    

        axios.get(config.API_URL + "company/get-license-types", {headers: authHeader()}).then(response => {
            
            var copyState = this.state;
            copyState.licenseTypes.push(...response.data);

            this.setState(copyState)

        })

        axios.get(config.API_URL + "company/get-license-usage-types", {headers: authHeader()}).then(response => {
            
            var copyState = this.state;
            copyState.licenseUsageTypes.push(...response.data);

            this.setState(copyState)
        })
    }   

    addCompany = () => {
        const {name, uniqueCode, licenseType, licenseUsageType, authorizedToExpire, hasAllSanctionLists, period, currentPeriod, maxSearch, remainingSearchCount, startDate, endDate} = this.state.company;

        if (izBlank(uniqueCode)) {
            message.error("Unique Code Empty!")
            return
        }

        const company = {name, uniqueCode, licenseType, licenseUsageType, authorizedToExpire, hasAllSanctionLists, period, currentPeriod, maxSearch, remainingSearchCount, startDate, endDate};

        AuthService.addCompany(company, authHeader).then(
            response => {
                let success = response.data;
                if (success) {
                    window.location = "/company-controller";
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )
            
    }
    
    updateCompany = () => {
        const {name, uniqueCode, licenseType, licenseUsageType, authorizedToExpire, hasAllSanctionLists, period, currentPeriod, maxSearch, remainingSearchCount, startDate, endDate} = this.state.company;

        const company = {name, uniqueCode, licenseType, licenseUsageType, authorizedToExpire, hasAllSanctionLists, period, currentPeriod, maxSearch, remainingSearchCount, startDate, endDate};

        AuthService.updateCompany(company, authHeader, this.state.companyID).then(
            response => {
                let success = response.data;
                if (success) {
                    window.location = "/company-controller";
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )
    }


    handleInputChange = (e) => {
        const {name, value} = e.target

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                [name]: value
            }
        }))

    }

    handleStartDateChange = (date,dateString) => {

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                startDate: dateString
            }
        }))        
        
    };

    handleEndDateChange = (date,dateString) => {

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                endDate: dateString
            }
        }))        
        
    };

    handleCompanyChange = (value) => {

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                company: value
            }
        }))

    }

    handleLicenseTypeChange = (value) => {

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                licenseType: value
            }
        }))

    }

    handleLicenseUsageTypeChange = (value) => {

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                licenseUsageType: value
            }
        }))

    }

    handleAuthorizedToExpireSwitchChange = (e) => {

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                authorizedToExpire: !this.state.company.authorizedToExpire
            }
        }))

    }

    handleHasAllSanctionListsSwitchChange = (e) => {

        this.setState(prevState => ({
            company: {
                ...prevState.company,
                hasAllSanctionLists: !this.state.company.hasAllSanctionLists
            }
        }))

    }

    


    render(){
        
        return(

            <>
            <section className="user-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="form-box-user custom-ant-input-wrapper">
                                <div>
                                    <form method="POST" action="">

                                    <h2 style={{textAlign: "center"}}>Company</h2>
                                    <br/>

                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="text"
                                                   value={this.state.company.name}
                                                   name="name"
                                                   placeholder={i18n.t('company_input_name')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>

                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="text"
                                                   value={this.state.company.uniqueCode}
                                                   name="uniqueCode"
                                                   placeholder={i18n.t('company_input_uniqueCode')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>

                                        <hr color='#204f79'/>

                                        <br/>
                                        <h2 style={{textAlign: "center"}}>License</h2>
                                        <br/>

                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="number"
                                                   value={this.state.company.period}
                                                   name="period"
                                                   placeholder={i18n.t('company_input_period')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>

                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="number"
                                                   value={this.state.company.currentPeriod}
                                                   name="currentPeriod"
                                                   placeholder={i18n.t('company_input_current_period')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>

                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="number"
                                                   value={this.state.company.maxSearch}
                                                   name="maxSearch"
                                                   placeholder={i18n.t('company_input_max_search')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>
                                        
                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="number"
                                                value={this.state.company.remainingSearchCount}
                                                name="remainingSearchCount"
                                                placeholder={i18n.t('company_input_remaining_search_count')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <div className="custom-ant-selection">
                                            <Select
                                                showSearch
                                                value={this.state.company.licenseType}
                                                allowClear
                                                suffixIcon={<ReadOutlined/>}
                                                optionFilterProp="children"
                                                placeholder={i18n.t("company_input_license_type")}
                                                onChange={value => this.handleLicenseTypeChange(value)}
                                            >
                                                {
                                                    this.state.licenseTypes.map(licenseType => (
                                                        <Select.Option key={licenseType} value={licenseType}>{licenseType}</Select.Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>

                                        <div className="custom-ant-selection">
                                            <Select
                                                value={this.state.company.licenseUsageType}
                                                showSearch
                                                allowClear
                                                suffixIcon={<ReadOutlined/>}
                                                optionFilterProp="children"
                                                placeholder={i18n.t("company_input_license_usage_type")}
                                                onChange={value => this.handleLicenseUsageTypeChange(value)}
                                            >
                                                {
                                                    this.state.licenseUsageTypes.map(licenseUsageType => (
                                                        <Select.Option key={licenseUsageType} value={licenseUsageType}>{licenseUsageType}</Select.Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>

                                        <div>
                                            <DatePicker 
                                                onChange={this.handleStartDateChange}
                                                name="startDate" 
                                                className="date-picker" 
                                                placeholder={i18n.t('company_input_start_date')}
                                                value = {moment(this.state.company.startDate)}/>
                                        </div>

                                        <div>
                                            <DatePicker 
                                                onChange={this.handleEndDateChange} 
                                                name="endDate"
                                                className="date-picker" 
                                                placeholder={i18n.t('company_input_end_date')}
                                                value = {moment(this.state.company.endDate)}/>
                                        </div>

                                        <div className="pb-20">
                                        
                                            <span className="ml-20 mr-20">{i18n.t('company_input_authorized_to_expire')}</span>
                                            <Switch
                                                checked = {this.state.company.authorizedToExpire}
                                                onChange={this.handleAuthorizedToExpireSwitchChange}
                                                name="authorizedToExpire"
                                                checkedChildren={i18n.t('user_input_enabled')}
                                                unCheckedChildren={i18n.t('user_input_disabled')}
                                            />

                                        </div>

                                        <div className="pb-20">
                                        
                                            <span className="ml-20 mr-20">{i18n.t('company_input_has_all_sanction_lists')}</span>
                                            <Switch
                                                checked = {this.state.company.hasAllSanctionLists}
                                                onChange={this.handleHasAllSanctionListsSwitchChange}
                                                name="hasAllSanctionLists"
                                                checkedChildren={i18n.t('user_input_enabled')}
                                                unCheckedChildren={i18n.t('user_input_disabled')}
                                            />
                                            
                                        </div>

                                        <Button
                                            className="custom-button"
                                            type="button"
                                            onClick={this.state.pageMode == "update" ? this.updateCompany : this.addCompany}
                                            >
                                            {this.state.pageMode == "update" ? i18n.t('update_company') : i18n.t('add_company')}
                                        </Button> 
                                        </form>
                                        
                                                                           
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            
            </>
            
        );

    }

}